<template>
  <v-dialog v-model="navigation.CRMWhatsappContactFilesDialogIsVisible" @update:model-value="navigation.CRMWhatsappContactFilesDialogIsVisible == false ? closeCRMWhatsappContactFilesDialog() : null" max-width="60vw">
    <v-card max-width="60vw">
      <div v-if="loader.selectCRMWhatsappContactFileFromCRMWhatsappContactFilesDialog" style="display: flex; justify-content: center; align-items: center; width: 100%; padding: 10px 0px;">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </div>
      <div v-else>
        <v-text-field 
          ref="CRMWhatsappContactFilesSearchQuery"
          v-model="input.CRMWhatsappContactFilesSearchQuery" 
          :append-inner-icon="input.CRMWhatsappContactFilesSearchQuery && /\S/.test(input.CRMWhatsappContactFilesSearchQuery) ? 'mdi-alphabetical-variant-off' : 'mdi-alphabetical-variant'" 
          @click:append-inner="$generalFunctions.default.blurInput(this, 'CRMWhatsappContactFilesSearchQuery'); input.CRMWhatsappContactFilesSearchQuery = null" 
          label="Búsqueda rápida" 
          variant="solo-filled" 
          density="compact"
          autocomplete="off"
          hide-details
          style="margin: 15px 15px 10px 15px;"
        ></v-text-field>
        <v-data-table :items="filteredCRMWhatsappContactFiles" :headers="display.CRMWhatsappContactFileHeaders" :fixed-header="true" :items-per-page="filteredCRMWhatsappContactFiles.length > 25 ? 25 : -1">
          <template v-slot:header.CRMWhatsappContactFileID>
            <p><strong>ID</strong></p>
          </template>
          <template v-slot:header.CRMWhatsappContactFileName>
            <p><strong>NOMBRE</strong></p>
          </template>
          <template v-slot:header.CRMWhatsappContactFileDescription>
            <p><strong>DESCRIPCIÓN</strong></p>
          </template>
          <template v-slot:header.CRMWhatsappContactFileCreationDatetime>
            <p><strong>CREACIÓN</strong></p>
          </template>
          <template v-slot:header.CRMWhatsappContactFileUpdateDatetime>
            <p><strong>ACTUALIZACIÓN</strong></p>
          </template>
          <template v-slot:item.CRMWhatsappContactFileID="{ item }">
            <v-tooltip :disabled="systemInformationData.tooltipDisabled" text="Copiar ID al portapapeles" location="top">
              <template v-slot:activator="{ props }">
                <p v-bind="props" @click="$generalFunctions.default.copyToClipboard(this, `ID del archivo del contacto`, 'o', item.CRMWhatsappContactFileID)" class="hoverableElement" style="user-select: none;"><strong>{{ item.CRMWhatsappContactFileID }}</strong></p>
              </template>
            </v-tooltip>
          </template>
          <template v-slot:item.CRMWhatsappContactFileDescription="{ item }">
            <p>{{ item.CRMWhatsappContactFileDescription && /\S/.test(item.CRMWhatsappContactFileDescription) ? item.CRMWhatsappContactFileDescription : 'Sin descripción' }}</p>
          </template>
          <template v-slot:item.CRMWhatsappContactFileCreationDatetime="{ item }">
            <v-chip v-if="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == item.CRMWhatsappContactFileCreationCRMAgentID)" :color="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == item.CRMWhatsappContactFileCreationCRMAgentID).CRMAgentColor || 'primary'" variant="flat" style="cursor: default; user-select: none;">
              <div style="display: flex; align-items: center;">
                <img :src="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == item.CRMWhatsappContactFileCreationCRMAgentID).CRMAgentProfilePictureURL || require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                <div style="display: flex; flex-direction: column;">
                  <p style="margin: 0;">{{ systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == item.CRMWhatsappContactFileCreationCRMAgentID).CRMAgentName || 'No registrado' }}</p>
                  <div style="display: flex; align-items: center; gap: 5px;">
                    <v-icon size="xx-small">mdi-clock-outline</v-icon>
                    <p style="font-size: xx-small;">{{ $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(item.CRMWhatsappContactFileCreationDatetime) }}</p>
                  </div>
                </div>
              </div>
            </v-chip>
            <v-chip v-else :color="'primary'" variant="flat" style="cursor: default; user-select: none;">
              <div style="display: flex; align-items: center;">
                <img :src="require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                <div style="display: flex; flex-direction: column;">
                  <p style="margin: 0;">No registrado</p>
                  <div style="display: flex; align-items: center; gap: 5px;">
                    <v-icon size="xx-small">mdi-clock-outline</v-icon>
                    <p style="font-size: xx-small;">{{ $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(item.CRMWhatsappContactFileCreationDatetime) }}</p>
                  </div>
                </div>
              </div>
            </v-chip>
          </template>
          <template v-slot:item.CRMWhatsappContactFileUpdateDatetime="{ item }">
            <v-chip v-if="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == item.CRMWhatsappContactFileUpdateCRMAgentID)" :color="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == item.CRMWhatsappContactFileUpdateCRMAgentID).CRMAgentColor || 'primary'" variant="flat" style="cursor: default; user-select: none;">
              <div style="display: flex; align-items: center;">
                <img :src="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == item.CRMWhatsappContactFileUpdateCRMAgentID).CRMAgentProfilePictureURL || require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                <div style="display: flex; flex-direction: column;">
                  <p style="margin: 0;">{{ systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == item.CRMWhatsappContactFileUpdateCRMAgentID).CRMAgentName || 'No registrado' }}</p>
                  <div style="display: flex; align-items: center; gap: 5px;">
                    <v-icon size="xx-small">mdi-clock-outline</v-icon>
                    <p style="font-size: xx-small;">{{ $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(item.CRMWhatsappContactFileUpdateDatetime) }}</p>
                  </div>
                </div>
              </div>
            </v-chip>
            <v-chip v-else :color="'primary'" variant="flat" style="cursor: default; user-select: none;">
              <div style="display: flex; align-items: center;">
                <img :src="require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                <div style="display: flex; flex-direction: column;">
                  <p style="margin: 0;">No registrado</p>
                  <div style="display: flex; align-items: center; gap: 5px;">
                    <v-icon size="xx-small">mdi-clock-outline</v-icon>
                    <p style="font-size: xx-small;">{{ $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(item.CRMWhatsappContactFileUpdateDatetime) }}</p>
                  </div>
                </div>
              </div>
            </v-chip>
          </template>
          <template v-slot:item.CRMWhatsappContactFileURL="{ item }">
            <img @click="this.$root.dialogComponent.openMediaDialog(item.CRMWhatsappContactFileURL, item.CRMWhatsappContactFileName, 'webp')" :src="item.CRMWhatsappContactFileURL" draggable="false" class="hoverableText" style="height: 100px; width: auto;">
          </template>
          <template v-slot:item.CRMWhatsappContactFileUpdateAction="{ item }">
            <v-tooltip :disabled="systemInformationData.tooltipDisabled" text="Actualizar archivo del contacto" location="bottom">
              <template v-slot:activator="{ props }">
                <v-icon v-bind="props" @click="$root.dialogComponent.openCRMWhatsappContactFileDialog(navigation.CRMWhatsappContactID, item, 'update')" icon="mdi-pencil" color="warning" class="hoverableElement"></v-icon>
              </template>
            </v-tooltip>
          </template>
          <template v-slot:item.CRMWhatsappContactFileDeleteAction="{ item }">
            <v-tooltip :disabled="systemInformationData.tooltipDisabled" text="Eliminar archivo del contacto" location="bottom">
              <template v-slot:activator="{ props }">
                <v-icon v-bind="props" @click="$root.dialogComponent.openCRMWhatsappContactFileDialog(navigation.CRMWhatsappContactID, item, 'delete')" icon="mdi-delete" color="error" class="hoverableElement"></v-icon>
              </template>
            </v-tooltip>
          </template>
          <template v-if="filteredCRMWhatsappContactFiles.length <= 25" v-slot:bottom></template>
        </v-data-table>
      </div>
    </v-card>
  </v-dialog>
</template>
  
<style scoped>
</style>

<script>
  import { systemInformation } from '@/utilities/systemInformation';
  import websocket from '@/utilities/websocket';
  export default {
    inject: ['$generalFunctions', '$displayFunctions'],
    data: () => 
    ({
      input:
      {
        CRMWhatsappContactFilesSearchQuery: null
      },
      display: 
      {
        CRMWhatsappContactFiles: [],
        CRMWhatsappContactFileHeaders: 
        [
          {title: 'ID', key: 'CRMWhatsappContactFileID', sortable: false},
          {title: 'NOMBRE', key: 'CRMWhatsappContactFileName', sortable: false},
          {title: 'DESCRIPCIÓN', key: 'CRMWhatsappContactFileDescription', sortable: false},
          {title: 'CREACIÓN', key: 'CRMWhatsappContactFileCreationDatetime', sortable: false},
          {title: 'ACTUALIZACIÓN', key: 'CRMWhatsappContactFileUpdateDatetime', sortable: false},
          {title: null, key: 'CRMWhatsappContactFileURL', sortable: false},
          {title: null, key: 'CRMWhatsappContactFileUpdateAction', sortable: false},
          {title: null, key: 'CRMWhatsappContactFileDeleteAction', sortable: false}
        ]
      },
      navigation: 
      {
        CRMWhatsappContactFilesDialogIsVisible: false,
        CRMWhatsappContactID: null
      },
      loader: 
      {
        selectCRMWhatsappContactFileFromCRMWhatsappContactFilesDialog: false
      },
      websocketCallback:
      {
        updateCRMWhatsappContactFileFromCRMWhatsappContactFileDialog: null,
        deleteCRMWhatsappContactFileFromCRMWhatsappContactFileDialog: null
      },
      systemInformationData: 
      {
        CRMAccountID: null,
        CRMAgent: null,
        CRMAgents: [],
        tooltipDisabled: false,
        updateSubscription: null
      }
    }),

    computed:
    {
      filteredCRMWhatsappContactFiles() {
        if (this.input.CRMWhatsappContactFilesSearchQuery == null || !/\S/.test(this.input.CRMWhatsappContactFilesSearchQuery)) return this.display.CRMWhatsappContactFiles;
        return this.display.CRMWhatsappContactFiles.filter(CRMWhatsappContactFile =>
          (CRMWhatsappContactFile.CRMWhatsappContactFileID && CRMWhatsappContactFile.CRMWhatsappContactFileID.toString().includes(this.input.CRMWhatsappContactFilesSearchQuery.toLowerCase())) ||
          (CRMWhatsappContactFile.CRMWhatsappContactFileName && CRMWhatsappContactFile.CRMWhatsappContactFileName.toLowerCase().includes(this.input.CRMWhatsappContactFilesSearchQuery.toLowerCase())) ||
          (CRMWhatsappContactFile.CRMWhatsappContactFileDescription && CRMWhatsappContactFile.CRMWhatsappContactFileDescription.toLowerCase().includes(this.input.CRMWhatsappContactFilesSearchQuery.toLowerCase()))
        );
      }
    },

    methods:
    {

      async selectCRMWhatsappContactFileFromCRMWhatsappContactFilesDialog(){
        this.loader.selectCRMWhatsappContactFileFromCRMWhatsappContactFilesDialog = true;
        const selectCRMWhatsappContactFileFromCRMWhatsappContactFilesDialogRequestQuery =
        {
          'localStorage':
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID,
            'CRMAgentID': this.systemInformationData.CRMAgent.CRMAgentID
          },
          'CRMWhatsappContactID': this.navigation.CRMWhatsappContactID
        };
        const selectCRMWhatsappContactFileFromCRMWhatsappContactFilesDialogResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappContact/CRMWhatsappContactFile/functions/selectCRMWhatsappContactFileFromCRMWhatsappContactFilesDialog', selectCRMWhatsappContactFileFromCRMWhatsappContactFilesDialogRequestQuery);
        if (selectCRMWhatsappContactFileFromCRMWhatsappContactFilesDialogResult.success){
          this.display.CRMWhatsappContactFiles = selectCRMWhatsappContactFileFromCRMWhatsappContactFilesDialogResult.result;
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog(`selectCRMWhatsappContactFileFromCRMWhatsappContactFilesDialog_${this.navigation.CRMWhatsappContactID}_error`, 'error', `Ha ocurrido un error inesperado al seleccionar el archivo del contacto ${this.navigation.CRMWhatsappContactID}, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema`, null, true);
          this.closeCRMWhatsappContactFilesDialog();
        }
        this.loader.selectCRMWhatsappContactFileFromCRMWhatsappContactFilesDialog = false;
      },    


      connectWebsocket(){
        websocket.connectWebsocket();
        this.websocketCallback.updateCRMWhatsappContactFileFromCRMWhatsappContactFileDialog = async (websocketMessageData) => {
          if (this.navigation.CRMWhatsappContactID == websocketMessageData.websocketMessageContent.CRMWhatsappContactID){
            const updatedCRMWhatsappContactFile = this.display.CRMWhatsappContactFiles.find(CRMWhatsappContactFile => CRMWhatsappContactFile.CRMWhatsappContactFileID == websocketMessageData.websocketMessageContent.CRMWhatsappContactFileID);
            if (updatedCRMWhatsappContactFile){
              updatedCRMWhatsappContactFile.CRMWhatsappContactFileName = websocketMessageData.websocketMessageContent.CRMWhatsappContactFileName;
              updatedCRMWhatsappContactFile.CRMWhatsappContactFileDescription = websocketMessageData.websocketMessageContent.CRMWhatsappContactFileDescription;
              updatedCRMWhatsappContactFile.CRMWhatsappContactFileUpdateDatetime = websocketMessageData.websocketMessageContent.CRMWhatsappContactFileUpdateDatetime;
              updatedCRMWhatsappContactFile.CRMWhatsappContactFileUpdateCRMAgentID = websocketMessageData.websocketMessageContent.CRMWhatsappContactFileUpdateCRMAgentID;
              if (websocketMessageData.websocketMessageContent.CRMWhatsappContactFileUpdateCRMAgentID != this.systemInformationData.CRMAgent.CRMAgentID) this.$root.notificationDialog.showSystemNotificationDialog('/CRMWhatsappContact/functions/updateCRMWhatsappContactFileFromCRMWhatsappContactFileDialog_info', 'info', `${this.systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == websocketMessageData.websocketMessageContent.CRMWhatsappContactFileUpdateCRMAgentID) ? this.systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == websocketMessageData.websocketMessageContent.CRMWhatsappContactFileUpdateCRMAgentID).CRMAgentName : 'Un agente'} ha actualizado el archivo ${updatedCRMWhatsappContactFile.CRMWhatsappContactFileName} del contacto`, null, true);
            }
          }
        };
        this.websocketCallback.deleteCRMWhatsappContactFileFromCRMWhatsappContactFileDialog = async (websocketMessageData) => {
          if (this.navigation.CRMWhatsappContactID == websocketMessageData.websocketMessageContent.CRMWhatsappContactID){
            const deletedCRMWhatsappContactFile = this.display.CRMWhatsappContactFiles.find(CRMWhatsappContactFile => CRMWhatsappContactFile.CRMWhatsappContactFileID == websocketMessageData.websocketMessageContent.CRMWhatsappContactFileID);
            if (deletedCRMWhatsappContactFile){
              this.display.CRMWhatsappContactFiles = this.display.CRMWhatsappContactFiles.filter(CRMWhatsappContactFile => CRMWhatsappContactFile.CRMWhatsappContactFileID != websocketMessageData.websocketMessageContent.CRMWhatsappContactFileID);
              if (websocketMessageData.websocketMessageContent.CRMWhatsappContactFileUpdateCRMAgentID != this.systemInformationData.CRMAgent.CRMAgentID) this.$root.notificationDialog.showSystemNotificationDialog('/CRMWhatsappContact/functions/deleteCRMWhatsappContactFileFromCRMWhatsappContactFileDialog_info', 'info', `${this.systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == websocketMessageData.websocketMessageContent.CRMWhatsappContactFileUpdateCRMAgentID) ? this.systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == websocketMessageData.websocketMessageContent.CRMWhatsappContactFileUpdateCRMAgentID).CRMAgentName : 'Un agente'} ha eliminado el archivo ${deletedCRMWhatsappContactFile.CRMWhatsappContactFileName} del contacto`, null, true);
            }
          }
        };
        if (this.websocketCallback.updateCRMWhatsappContactFileFromCRMWhatsappContactFileDialog) websocket.addWebsocketMessageListener('/CRMWhatsappContact/CRMWhatsappContactFile/functions/updateCRMWhatsappContactFileFromCRMWhatsappContactFileDialog', this.websocketCallback.updateCRMWhatsappContactFileFromCRMWhatsappContactFileDialog);
        if (this.websocketCallback.deleteCRMWhatsappContactFileFromCRMWhatsappContactFileDialog) websocket.addWebsocketMessageListener('/CRMWhatsappContact/CRMWhatsappContactFile/functions/deleteCRMWhatsappContactFileFromCRMWhatsappContactFileDialog', this.websocketCallback.deleteCRMWhatsappContactFileFromCRMWhatsappContactFileDialog);
      },

      disconnectWebsocket(){
        if (this.websocketCallback.updateCRMWhatsappContactFileFromCRMWhatsappContactFileDialog) websocket.removeWebsocketMessageListener('/CRMWhatsappContact/CRMWhatsappContactFile/functions/updateCRMWhatsappContactFileFromCRMWhatsappContactFileDialog', this.websocketCallback.updateCRMWhatsappContactFileFromCRMWhatsappContactFileDialog);
        if (this.websocketCallback.deleteCRMWhatsappContactFileFromCRMWhatsappContactFileDialog) websocket.removeWebsocketMessageListener('/CRMWhatsappContact/CRMWhatsappContactFile/functions/deleteCRMWhatsappContactFileFromCRMWhatsappContactFileDialog', this.websocketCallback.deleteCRMWhatsappContactFileFromCRMWhatsappContactFileDialog);
        this.websocketCallback.updateCRMWhatsappContactFileFromCRMWhatsappContactFileDialog = null;
        this.websocketCallback.deleteCRMWhatsappContactFileFromCRMWhatsappContactFileDialog = null;
      },

      async getSystemInformationData(){
        try {
          systemInformation.setGeneralFunctions(this.$generalFunctions.default);
          const systemInformationResult = await systemInformation.startup();
          if (systemInformationResult.success){
            this.systemInformationData.CRMAccountID = systemInformation.getCRMAccountID;
            this.systemInformationData.CRMAgent = systemInformation.getCRMAgent;
            this.systemInformationData.tooltipDisabled = systemInformation.getTooltipDisabled;
            this.systemInformationData.CRMAgents = systemInformation.getCRMAgents;
            if (!this.systemInformationData.updateSubscription){
              this.systemInformationData.updateSubscription = systemInformation.subscribeToUpdate((updatedSystemInformationData) => {
                this.systemInformationData.tooltipDisabled = updatedSystemInformationData.tooltipDisabled;
              });
            }          
          } else {
            this.$root.notificationDialog.showSystemNotificationDialog('closeCRMWhatsappConversationDialog_getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
          }
        } catch {
          this.$root.notificationDialog.showSystemNotificationDialog('closeCRMWhatsappConversationDialog_getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
        }
      },

      async openCRMWhatsappContactFilesDialog(CRMWhatsappContactID){
        this.navigation.CRMWhatsappContactID = CRMWhatsappContactID;
        await this.getSystemInformationData();
        await this.selectCRMWhatsappContactFileFromCRMWhatsappContactFilesDialog();
        this.connectWebsocket();
        this.navigation.CRMWhatsappContactFilesDialogIsVisible = true;
        this.$generalFunctions.default.focusInput(this, 'CRMWhatsappContactFilesSearchQuery');
      },

      closeCRMWhatsappContactFilesDialog(){
        this.navigation.CRMWhatsappContactFilesDialogIsVisible = false;
        this.$emit('closeCRMWhatsappContactFilesDialog');
      }
    }
  }
</script>